import { render, staticRenderFns } from "./StandardProjects.vue?vue&type=template&id=9a6626f4"
import script from "./StandardProjects.vue?vue&type=script&lang=js"
export * from "./StandardProjects.vue?vue&type=script&lang=js"
import style0 from "./StandardProjects.vue?vue&type=style&index=0&id=9a6626f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports